import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LanguageContext } from "./contexts/LanguageContext";
import Rotate from "./components/Rotate/Rotate.jsx";
import BottomPanel from "./components/BottomPanel/BottomPanel.jsx";
import LanguageSelector from "./components/LanguageSelector/LanguageSelector.jsx";
// import ClickToBuy from "./components/ClickToBuy/ClickToBuy.jsx";
import TempleMap from "./components/TempleMap/TempleMap.jsx";
import PlaceDetails from "./components/PlaceDetails/PlaceDetails.jsx";

function App() {
  const { language } = useContext(LanguageContext);
  // alert(language);

  return (
    <Router>
      <Rotate />
      <Routes>
        {/* Route for language selection */}
        {!language && (
          <Route
            path="*"
            element={
              <BottomPanel>
                <LanguageSelector />
              </BottomPanel>
            }
          />
        )}

        {language && (
          <>
            <Route
              path="/"
              element={<Navigate to="/places/what_is_manpukuji_temple" />}
            />
            <Route path="/temple-map" element={<TempleMap />} />
            <Route path="/places/:name" element={<PlaceDetails />} />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
